import axios, { AxiosRequestConfig } from "axios";
import appconfig from "../../AppConfig";

export const updateConversionRateApi = async (rate: number): Promise<boolean> => {
  const config = {
    baseURL: appconfig.baseURL,
  } as AxiosRequestConfig;

  try {
    const response = await axios.post("/settings/updateConversionRate", { rate }, config);
    return response.data === true;
  } catch (err) {
    console.log(err);
    return false;
  }
};
